/* eslint-disable */
import React from 'react';
import {Button, Checkbox, Dropdown, Icon, Pagination, Select, Table, Menu, Drawer, Row, Col, Tabs} from "antd";
import ListNotProcess from './ListNotProcess';
import ListProcessing from './ListProcessing';
import ListProcessed from './ListProcessed';

const Option = Select.Option;
const TabPane = Tabs.TabPane;

const menu = (
    <Menu className="a-dropdown--set-field__menu">
        <div className="close-field-menu">
            <Icon type="close"/>
        </div>
        <Menu.Item className="a-dropdown--set-field__item">
            <Checkbox className="a-checkbox--set-field">Mã kiểm kê </Checkbox>
        </Menu.Item>
        <Menu.Item className="a-dropdown--set-field__item">
            <Checkbox className="a-checkbox--set-field">Thời gian kiểm kê</Checkbox>
        </Menu.Item>
        <Menu.Item className="a-dropdown--set-field__item">
            <Checkbox className="a-checkbox--set-field">Kho kiểm kê</Checkbox>
        </Menu.Item>
        <Menu.Item className="a-dropdown--set-field__item">
            <Checkbox className="a-checkbox--set-field">Thời gian đối soát</Checkbox>
        </Menu.Item>
        <Menu.Item className="a-dropdown--set-field__item">
            <Checkbox className="a-checkbox--set-field">Thất lạc </Checkbox>
        </Menu.Item>
        <Menu.Item className="a-dropdown--set-field__item">
            <Checkbox className="a-checkbox--set-field">Nhập kho</Checkbox>
        </Menu.Item>
        <Menu.Item className="a-dropdown--set-field__item">
            <Checkbox className="a-checkbox--set-field">Đã xử lý</Checkbox>
        </Menu.Item>
        <Menu.Item className="a-dropdown--set-field__item">
            <Checkbox className="a-checkbox--set-field">Chờ xử lý</Checkbox>
        </Menu.Item>
        <Menu.Item className="a-dropdown--set-field__item">
            <Checkbox className="a-checkbox--set-field">Chưa xử lý</Checkbox>
        </Menu.Item>
        <Menu.Item className="a-dropdown--set-field__item">
            <Checkbox className="a-checkbox--set-field">Người kiểm kê</Checkbox>
        </Menu.Item>
    </Menu>
);

class InventoryList extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <div className="a-content__top a-content__top--page-list action-inventory-history mt-0">
                    <div className="a-content--page-list__top-action " id="content-list">
                        <Button type="primary"
                                className="a-btn a-btn--primary a-btn--h-25 a-btn--font-small a-text--regular mr-3 "
                                ghost>Xuất CSV
                        </Button>
                        <Dropdown overlay={menu} trigger={['click']} overlayClassName={'a-dropdown--set-field'}>
                            <Button type="primary"
                                    className="a-btn a-btn--primary a-btn--h-25 a-btn--font-small a-text--regular"
                                    ghost>Thiết lập cột thông tin
                            </Button>
                        </Dropdown>
                        <Button type="primary"
                                className="a-btn a-btn--primary a-btn--h-25 a-btn--font-small a-text--regular ml-3 ">Kiểm kê
                        </Button>
                    </div>
                </div>
                <Tabs defaultActiveKey="1" className="a-tabs a-tabs--inventory-history">
                    <TabPane tab="Đang xử lý (100)" key="1"> <ListProcessing/></TabPane>
                    <TabPane tab="Đã xử lý " key="2 "> <ListProcessed/></TabPane>
                </Tabs>
            </React.Fragment>
        );
    }
}

export default InventoryList;